import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReadFiltersAvailableQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadFiltersAvailableQuery = { readFiltersAvailable: boolean };

export type SetObjectSchemaReadFiltersMutationVariables = Types.Exact<{
  objectSchemaId: Types.Scalars['ID'];
  readFilters: Array<Types.ReadFilterInput> | Types.ReadFilterInput;
}>;


export type SetObjectSchemaReadFiltersMutation = { setObjectSchemaReadFilters?: boolean | null };


export const ReadFiltersAvailableDocument = gql`
    query ReadFiltersAvailable {
  readFiltersAvailable
}
    `;

/**
 * __useReadFiltersAvailableQuery__
 *
 * To run a query within a React component, call `useReadFiltersAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadFiltersAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadFiltersAvailableQuery({
 *   variables: {
 *   },
 * });
 */
export function useReadFiltersAvailableQuery(baseOptions?: Apollo.QueryHookOptions<ReadFiltersAvailableQuery, ReadFiltersAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadFiltersAvailableQuery, ReadFiltersAvailableQueryVariables>(ReadFiltersAvailableDocument, options);
      }
export function useReadFiltersAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadFiltersAvailableQuery, ReadFiltersAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadFiltersAvailableQuery, ReadFiltersAvailableQueryVariables>(ReadFiltersAvailableDocument, options);
        }
export type ReadFiltersAvailableQueryHookResult = ReturnType<typeof useReadFiltersAvailableQuery>;
export type ReadFiltersAvailableLazyQueryHookResult = ReturnType<typeof useReadFiltersAvailableLazyQuery>;
export type ReadFiltersAvailableQueryResult = Apollo.QueryResult<ReadFiltersAvailableQuery, ReadFiltersAvailableQueryVariables>;
export const SetObjectSchemaReadFiltersDocument = gql`
    mutation SetObjectSchemaReadFilters($objectSchemaId: ID!, $readFilters: [ReadFilterInput!]!) {
  setObjectSchemaReadFilters(
    objectSchemaId: $objectSchemaId
    readFilters: $readFilters
  )
}
    `;
export type SetObjectSchemaReadFiltersMutationFn = Apollo.MutationFunction<SetObjectSchemaReadFiltersMutation, SetObjectSchemaReadFiltersMutationVariables>;

/**
 * __useSetObjectSchemaReadFiltersMutation__
 *
 * To run a mutation, you first call `useSetObjectSchemaReadFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetObjectSchemaReadFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setObjectSchemaReadFiltersMutation, { data, loading, error }] = useSetObjectSchemaReadFiltersMutation({
 *   variables: {
 *      objectSchemaId: // value for 'objectSchemaId'
 *      readFilters: // value for 'readFilters'
 *   },
 * });
 */
export function useSetObjectSchemaReadFiltersMutation(baseOptions?: Apollo.MutationHookOptions<SetObjectSchemaReadFiltersMutation, SetObjectSchemaReadFiltersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetObjectSchemaReadFiltersMutation, SetObjectSchemaReadFiltersMutationVariables>(SetObjectSchemaReadFiltersDocument, options);
      }
export type SetObjectSchemaReadFiltersMutationHookResult = ReturnType<typeof useSetObjectSchemaReadFiltersMutation>;
export type SetObjectSchemaReadFiltersMutationResult = Apollo.MutationResult<SetObjectSchemaReadFiltersMutation>;
export type SetObjectSchemaReadFiltersMutationOptions = Apollo.BaseMutationOptions<SetObjectSchemaReadFiltersMutation, SetObjectSchemaReadFiltersMutationVariables>;